module.exports = __webpack_public_path__ + "static/media/buddy_referral.3c78a9a9.svg";